import { AddCircleOutlineTwoTone, CheckCircleTwoTone, DeleteTwoTone, DescriptionTwoTone, EditNoteTwoTone, EditTwoTone, GroupWorkTwoTone, HelpTwoTone, HomeTwoTone, PendingTwoTone, ScheduleTwoTone, SchoolTwoTone, SportsEsportsTwoTone } from '@mui/icons-material';
import React from 'react';
const MatIcon = ({ name, color }) => {
    function getIcon(name, color) {
        switch (name) {
            case "add_circle":
                return <AddCircleOutlineTwoTone color={color?color:"inherit"} />;
            case "edit":
                return <EditTwoTone color={color} />;
            case "delete":
                return <DeleteTwoTone color={color} />;
            case "home":
                return <HomeTwoTone color={color?color:"inherit"} />;
            case "group_work":
                return <GroupWorkTwoTone color={color} />;
            case "schedule":
                return <ScheduleTwoTone color={color} />;
            case "school":
                return <SchoolTwoTone color={color} />;
            case "sports_esports":
                return <SportsEsportsTwoTone color={color} />;
            case "pending":
                return <PendingTwoTone color={color} />;
            case "description":
                return <DescriptionTwoTone color={color} />;
            case "check_circle":
                return <CheckCircleTwoTone color={color} />;
            case "help":
                return <HelpTwoTone color={color} />;

            default:
                return <EditNoteTwoTone />;
        }
    }
    return (getIcon(name, color));
}

export default MatIcon;